import { getReqAuth } from '../../api';
import axios from 'axios';
import config from '../../../util/config';

export const getAvailableRoles = (cb) => {
  getReqAuth('/webapi/institute/adminRoles/roles', {}, '', cb);
};

export const getAdminsForRoles = (cb) => {
  getReqAuth('/webapi/institute/adminRoles', {}, '', cb);
};

export const updateAdminRoles = (adminId, roleSet, cb) => {
  const token = localStorage.getItem('jwtToken');

  if (token) {
    axios.defaults.headers.common.Authorization = token;
    axios
      .put(config.BASE_API_URL + '/webapi/institute/adminRoles/' + adminId + '/roles', { roleSet })
      .then((res) => {
        cb(null, res.data);
      })
      .catch((err) => {
        cb(err, null);
      });
  } else {
    cb('Not authenticated', null);
  }
};
